const sectionSizingChartHurryBoxCss = `
[data-type='section-sizing-chart-hurry-box'] [data-attribute='card-container'] {
  padding-top: var(--padding-top-desktop, 16px);
  padding-bottom: var(--padding-bottom-desktop, 0);
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card [data-attribute='card-accordions'] .wrap-accordion {
  margin-bottom: 10px;
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion {
  border: solid 2px #000000;
  border-radius: 10px;
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion .accordion-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  flex-wrap: wrap;
  cursor: pointer;
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion .accordion-title div:first-child {
  width: calc(100% - 25px);
  font-size: 18px;
  font-weight: bold !important;
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion .accordion-title div:last-child {
  display: flex;
  width: 25px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion .accordion-title div:last-child.open {
  transform: rotate(-180deg);
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion .accordion-content {
  max-height: 0;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion .accordion-content .wrap-content {
  padding: 10px;
  border-top: solid 2px #000000;
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion .accordion-content .wrap-content .wrap-img {
  margin-bottom: 15px;
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion .accordion-content .wrap-content .wrap-img img {
  display: block;
  width: 100%;
  height: auto;
}

[data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion .accordion-content .wrap-content .accordion-text {
  white-space: pre-line;
}

@container (max-width: 768px) {
  [data-type='section-sizing-chart-hurry-box'] [data-attribute='card-container'] {
    padding-top: var(--padding-top-mobile, 16px);
    padding-bottom: var(--padding-bottom-mobile, 0);
  }

  [data-type='section-sizing-chart-hurry-box'] .wrap-card .wrap-accordion .accordion-content.open {
    transition: none;
  }
}
`;
export default sectionSizingChartHurryBoxCss;
